











import { Component, Prop, Vue } from 'vue-property-decorator';
import { TakePlace, TakeRecord } from './types';

@Component
export default class RoomsBlock extends Vue {
  @Prop({ type: String, default: '' })
  readonly student_url!: string;

  @Prop({ type: String, default: '' })
  readonly record_url!: string;

  @Prop({ type: Boolean, default: '' })
  readonly webinar_started!: boolean;

  @Prop({ type: String, default: '' })
  readonly link_state!: string;

  @Prop({ type: Boolean, default: false })
  readonly isDateAfterToday!: boolean;

  @Prop({ type: String, default: '' })
  readonly date!: string;

  get dateText() {
    return !this.webinar_started
      ? TakePlace.WILL_TAKE_PLACE
      : TakePlace.TOOK_PLACE;
  }

  get roomsText() {
    return this.isDateAfterToday ? TakeRecord.ROOMS : TakeRecord.RECORD;
  }

  get linkData() {
    const linkData = {
      LINK_INVALID: {
        text: 'Ссылка устарела',
        url: null,
        isActive: false,
      },
      LINK_ACTIVE: {
        text: 'Посмотреть вебинар',
        url: this.student_url,
        isActive: true,
      },
      RECORD_IS_LOADING: {
        text: 'Запись загружается',
        url: null,
        isActive: false,
      },
      RECORD_LOADED: {
        text: 'Посмотреть запись',
        url: this.record_url,
        isActive: true,
      },
      RECORD_NOT_AVAILABLE: {
        text: 'Запись недоступна',
        url: null,
        isActive: false,
      },
    };
    return linkData;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/components/block/components/legend/components/roomsblock/RoomsBlock.vue